<div class="card shadow-sm mb-5">
  <div class="card-header text-white">
    <h3 class="mb-0"><i class="fa fa-money-check-alt"></i> Histórico de Transferencias</h3>
  </div>

  <div class="card-body">
    <!-- Filtros -->
    <div class="card p-3 mb-4 shadow-sm">
      <h5><i class="fa fa-filter"></i> Filtrar</h5>
      <div class="row g-3 align-items-end mt-2">
        <!-- Fecha inicio -->
        <div class="col-sm-6">
          <label for="startDate" class="form-label">Fecha inicio</label>
          <input type="date" id="startDate" [(ngModel)]="startDate" class="form-control" />
        </div>

        <!-- Fecha fin -->
        <div class="col-sm-6">
          <label for="endDate" class="form-label">Fecha final</label>
          <input type="date" id="endDate" [(ngModel)]="endDate" class="form-control" />
        </div>

        <div class="col-sm-6">
          <label for="filterAccount" class="form-label">Cuenta</label>
          <input type="text"
                id="filterAccount"
                [(ngModel)]="accountFilter"
                class="form-control"
                placeholder="Cuenta origen o destino"
                (keyup.enter)="updateFilter()" />
        </div>

        <!-- Botón buscar -->
        <div class="col-sm-6">
          <button class="btn btn-primary w-100" (click)="getTransfers()">
            <i class="fa fa-search"></i> Buscar
          </button>
        </div>
      </div>
    </div>

    <!-- Tabla -->
    <div class="table-responsive">
        <table class="table table-hover align-middle">
        <thead class="table-light">
          <tr>
            <th>Cuenta Origen</th>
            <th>Cuenta Destino</th>
            <th>Monto</th>
            <th>Estado</th>
            <th>Fechas</th>
            <th>Descripción</th>
            <th>Mensaje</th>
            <th class="td-center">Acciones</th>
          </tr>
        </thead>
        <tbody>
            <ng-container *ngIf="!loading">
                <tr *ngFor="let transfer of pagination.filter" [class.table-danger]="transfer.bamBankTransferLog.transactionStatus == 'VALIDATION_FAILED_BUSINESS_GROUP' || transfer.bamBankTransferLog.transactionStatus == 'UNCONTROLLED_INTERNAL_ERROR'">

                <!-- Cuenta Origen -->
                <td>
                    <div class="fw-bold">{{ transfer.bankDebit.accountNumber }}</div>
                    <small class="text-muted">
                    {{ transfer.sourceBankName }} ({{ transfer.sourceAccountType }})
                    </small>
                </td>

                <!-- Cuenta Destino -->
                <td>
                  <ng-container *ngIf="transfer.vendorBank ? transfer.vendorBankCredit : transfer.bankCredit; else noDestinationAccount">
                    <div class="fw-bold">
                      {{ transfer.vendorBank ? transfer.vendorBankCredit?.accountNumber : transfer.bankCredit?.accountNumber }}
                    </div>
                    <small class="text-muted">
                      {{ transfer.destinationBankName }} ({{ transfer.destinationAccountType }})
                    </small>
                  </ng-container>

                  <ng-template #noDestinationAccount>
                    <span class="text-muted">-</span>
                  </ng-template>
                </td>

                <!-- Monto -->
                <td class="fw-bold text-end">
                    {{ transfer.bamBankTransferLog.amount | currency:'Q' }}
                </td>

                <!-- Estado -->
                <td class="">
                    <span
                    class="badge bg-secondary"
                    [ngClass]="{
                        'bg-warning text-dark': transfer.bamBankTransferLog.transactionStatus === 'VALIDATION_WITH_ERRORS',
                        'bg-success': transfer.bamBankTransferLog.transactionStatus === 'SUCCESSFUL_VALIDATION',
                        'bg-primary': transfer.bamBankTransferLog.transactionStatus === 'CREATE',
                        'bg-danger': transfer.bamBankTransferLog.transactionStatus == 'VALIDATION_FAILED_BUSINESS_GROUP' || transfer.bamBankTransferLog.transactionStatus == 'UNCONTROLLED_INTERNAL_ERROR' || transfer.bamBankTransferLog.transactionStatus == 'FAILED',
                    }"
                    >
                    <i class="fa"
                        [ngClass]="{
                        'fa-hourglass-half': transfer.bamBankTransferLog.transactionStatus === 'VALIDATION_WITH_ERRORS',
                        'fa-thumbs-up': transfer.bamBankTransferLog.transactionStatus === 'SUCCESSFUL_VALIDATION',
                        'fa-check': transfer.bamBankTransferLog.transactionStatus === 'CREATE',
                        'fa-times-circle': transfer.bamBankTransferLog.transactionStatus == 'VALIDATION_FAILED_BUSINESS_GROUP' || transfer.bamBankTransferLog.transactionStatus == 'UNCONTROLLED_INTERNAL_ERROR' || transfer.bamBankTransferLog.transactionStatus == 'FAILED',
                        'fa-clock': transfer.bamBankTransferLog.transactionStatus === 'TIMEOUT'
                        }"
                    ></i>
                    <ng-container [ngSwitch]="transfer.bamBankTransferLog.transactionStatus">
                        <!-- <span *ngSwitchCase="'PENDING'"> Pendiente</span>
                        <span *ngSwitchCase="'SUCCESS'"> Éxito (falta aprobación)</span>
                        <span *ngSwitchCase="'ACCEPTED'"> Aceptado</span>
                        <span *ngSwitchCase="'FAILED'"> Fallido</span>
                        <span *ngSwitchCase="'TIMEOUT'"> Tiempo excedido</span> -->
                        <span *ngSwitchDefault>{{ transfer.bamBankTransferLog.transactionStatus }}</span>
                    </ng-container>
                    </span>

                    <span class="badge bg-primary" *ngIf="transfer.bamBankTransferLog.transactionType!=null">
                      <!-- <i class="fa fa-hourglass-half" ></i> -->
                      <ng-container [ngSwitch]="transfer.bamBankTransferLog.transactionStatus">
                          <span *ngSwitchDefault>{{ transfer.bamBankTransferLog.transactionType }}</span>
                      </ng-container>
                    </span>
                    <span class="badge" *ngIf="transfer.bamBankTransferLog.statusBatch!=null">
                      <!-- <i class="fa fa-hourglass-half" ></i> -->
                      <ng-container [ngSwitch]="transfer.bamBankTransferLog.statusBatch">
                        <span class="badge bg-danger" *ngSwitchCase="'FAILED'">FALLIDO</span>
                        <span class="badge bg-secondary" *ngSwitchDefault>{{ status(transfer.bamBankTransferLog.statusBatch).description }}</span>
                      </ng-container>
                    </span>
                </td>

                <!-- Fechas -->
                <td>
                    <div>
                        <strong>{{ formatCreatedAt(transfer.bamBankTransferLog.createdAt) }}</strong>
                        <div class="small text-muted">Creación</div>
                    </div>
                </td>

                <!-- Descripcion -->
                <td>
                    <span
                    *ngIf="transfer.bamBankTransferLog.description; else noDescription"
                    class="d-inline-block"
                    style="max-width: 250px; white-space: normal; word-break: break-word;"
                    [title]="transfer.bamBankTransferLog.description"
                    >
                    {{ transfer.bamBankTransferLog.description }}
                    </span>
                    <ng-template #noDescription>
                    <span class="text-muted">-</span>
                    </ng-template>
                </td>

                <!-- Error -->
                <td>
                  <div style="width: 250px;">
                    <span
                      *ngIf="transfer.bamBankTransferLog.message; else noError"
                      class="truncate-5-lines"
                      [title]="transfer.bamBankTransferLog.message"
                    >
                      {{ transfer.bamBankTransferLog.message }}
                    </span>
                  </div>

                  <ng-template #noError>
                    <span class="text-muted">-</span>
                  </ng-template>
                </td>
                <td class="ta">
                  <div>
                    <app-view-batch [batchId]="transfer.bamBankTransferLog.batchId" [accountNumber]="transfer.bankDebit.accountNumber" *ngIf="transfer.bamBankTransferLog.batchId!=null"/>
                  </div>
                </td>
              </tr>
              <tr *ngIf="pagination.filter.length === 0">
                  <td colspan="8" class="text-center text-muted">
                  <i class="fa fa-circle-info"></i> No se encontraron transferencias en el rango seleccionado
                  </td>
              </tr>
            </ng-container>
            <tr class="tr-middle" *ngIf="loading">
                <td colspan="8" class="">
                    <span class="display-5 text-center">
                        <app-loading-animation [height]="'3rem'"></app-loading-animation>
                        Cargando...
                    </span>
                </td>
            </tr>
        </tbody>
        </table>
    </div>

    <!-- Paginación -->
    <app-pagination-custom [elements]="pagination"></app-pagination-custom>
  </div>
</div>
